



















































import { Component, Vue } from 'vue-property-decorator';
import { carouselData } from './data';

@Component({
  name: 'HotNews',
  components: {},
})
export default class extends Vue {
  activeIndex = 0;
  carouselData = carouselData;

  // 打开新闻链接
  openNews(id) {
    this.$router.push({
      name: 'NewsDetail',
      query: {
        id,
      },
    });
  }
}
